"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var genIcon_1 = __importDefault(require("../../utils/genIcon"));
var BelowText_1 = __importDefault(require("../BelowText/BelowText"));
var reserveSpace_1 = __importDefault(require("../../utils/reserveSpace"));
var react_1 = require("react");
var main_1 = require("../../main");
/**
 * The Input is used to elicit a response from a user. It is built on top of the browser's native HTML input element.
 */
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.onFocusWrap = function (event) {
            var onFocus = _this.props.onFocus;
            return onFocus && onFocus();
        };
        _this.onChangeWrap = function (data) {
            var _a = _this.props, onChange = _a.onChange, uncontrolled = _a.uncontrolled, onEnter = _a.onEnter;
            if (uncontrolled || onEnter) {
                _this.setState({ value: data });
            }
            return onChange && onChange(data);
        };
        _this.onKeyDown = function (event) {
            var onEnter = _this.props.onEnter;
            if (event.key === 'Enter') {
                return onEnter && onEnter();
            }
        };
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, error = _a.error, fluid = _a.fluid, icon = _a.icon, iconPosition = _a.iconPosition, disabled = _a.disabled, type = _a.type;
            var classes = 'ui single-input';
            if (className) {
                classes += ' ' + className;
            }
            if (error) {
                classes += ' error';
            }
            if (fluid) {
                classes += ' fluid';
            }
            if (icon) {
                classes += " has-icon align-" + iconPosition;
            }
            if (type === 'password') {
                classes += ' has-icon align-right';
            }
            if (disabled) {
                classes += ' disabled';
            }
            if (_this.state.focused) {
                classes += ' focused';
            }
            return classes;
        };
        _this.togglePassword = function () {
            _this.setState(function (_a) {
                var hidden = _a.hidden;
                return ({ hidden: !hidden });
            });
        };
        _this.state = {
            value: _this.props.value ? _this.props.value : '',
            focused: false,
            hidden: false
        };
        return _this;
    }
    Input.getDerivedStateFromProps = function (props, state) {
        var valueCheck = (typeof props.value !== 'undefined' || state.value && !props.value) && state.value !== props.value;
        if (props.uncontrolled) {
            if (valueCheck) {
                return { value: props.value };
            }
        }
        return null;
    };
    Input.prototype.componentDidMount = function () {
        var type = this.props.type;
        if (type === 'password') {
            this.setState({ hidden: true });
        }
    };
    Input.prototype.render = function () {
        var _this = this;
        var _a = this.props, onBlur = _a.onBlur, placeholder = _a.placeholder, error = _a.error, helperText = _a.helperText, uncontrolled = _a.uncontrolled, value = _a.value, iconRoot = _a.iconRoot, icon = _a.icon, label = _a.label, indicator = _a.indicator, onChange = _a.onChange, onEnter = _a.onEnter, onFocus = _a.onFocus, iconPosition = _a.iconPosition, fluid = _a.fluid, disabled = _a.disabled, className = _a.className, min = _a.min, max = _a.max, step = _a.step, type = _a.type, search = _a.search, disablePasswordToggle = _a.disablePasswordToggle, reserveSpace = _a.reserveSpace, onSearchChange = _a.onSearchChange, onTextChange = _a.onTextChange, rest = __rest(_a, ["onBlur", "placeholder", "error", "helperText", "uncontrolled", "value", "iconRoot", "icon", "label", "indicator", "onChange", "onEnter", "onFocus", "iconPosition", "fluid", "disabled", "className", "min", "max", "step", "type", "search", "disablePasswordToggle", "reserveSpace", "onSearchChange", "onTextChange"]);
        return (React.createElement("div", __assign({}, rest, { className: this.genClasses() }),
            label && React.createElement(main_1.InputLabel, { label: label, indicator: indicator }),
            React.createElement("div", { className: "input-wrap" },
                React.createElement("input", __assign({ type: this.genInputType(), className: "input-box", placeholder: placeholder, onFocus: function (event) {
                        _this.setState({ focused: true });
                        _this.focus();
                        _this.onFocusWrap(event);
                    } }, this.genCleanedProps(), { onKeyPress: this.onKeyDown, ref: function (r) { return _this.inputRef = r; }, onBlur: function (event) {
                        _this.setState({ focused: false });
                        _this.blur();
                        return onBlur && onBlur();
                    }, value: uncontrolled ? this.state.value : value, onChange: function (event) { return _this.onChangeWrap(event.target.value); } })),
                this.genInputIcon()),
            reserveSpace_1.default(this.props) && React.createElement(BelowText_1.default, { error: error, helperText: helperText })));
    };
    Input.prototype.focus = function () {
        return this.inputRef && this.inputRef.focus();
    };
    Input.prototype.blur = function () {
        return this.inputRef && this.inputRef.blur();
    };
    Input.prototype.genCleanedProps = function () {
        var _a = this.props, onBlur = _a.onBlur, onFocus = _a.onFocus, placeholder = _a.placeholder, error = _a.error, helperText = _a.helperText, uncontrolled = _a.uncontrolled, value = _a.value, iconRoot = _a.iconRoot, icon = _a.icon, label = _a.label, indicator = _a.indicator, className = _a.className, fluid = _a.fluid, iconPosition = _a.iconPosition, onChange = _a.onChange, onEnter = _a.onEnter, search = _a.search, disablePasswordToggle = _a.disablePasswordToggle, type = _a.type, reserveSpace = _a.reserveSpace, onSearchChange = _a.onSearchChange, onTextChange = _a.onTextChange, cleanedProps = __rest(_a, ["onBlur", "onFocus", "placeholder", "error", "helperText", "uncontrolled", "value", "iconRoot", "icon", "label", "indicator", "className", "fluid", "iconPosition", "onChange", "onEnter", "search", "disablePasswordToggle", "type", "reserveSpace", "onSearchChange", "onTextChange"]);
        return cleanedProps;
    };
    Input.prototype.genInputIcon = function () {
        var _this = this;
        var _a = this.props, icon = _a.icon, iconRoot = _a.iconRoot, search = _a.search, type = _a.type, disablePasswordToggle = _a.disablePasswordToggle;
        var hidden = this.state.hidden;
        var inputIcon;
        if (type === 'password' && !disablePasswordToggle) {
            inputIcon = React.createElement(main_1.Icon, { name: hidden ? 'invisible' : 'visible', root: "common", onClick: this.togglePassword, className: "input-icon" });
        }
        else if (search) {
            inputIcon = React.createElement(main_1.Icon, { root: "common", name: "search", size: "small", className: "search-icon" });
        }
        else if (icon) {
            inputIcon = genIcon_1.default(icon, {
                root: iconRoot,
                size: 'small',
                className: 'input-icon',
                onClick: function () { return _this.inputRef.focus(); }
            });
        }
        return inputIcon;
    };
    Input.prototype.genInputType = function () {
        var type = this.props.type;
        var inputType = type;
        if (this.state.hidden) {
            inputType = 'password';
        }
        if (type === 'password' && !this.state.hidden) {
            inputType = 'text';
        }
        return inputType;
    };
    Input.defaultProps = {
        iconPosition: 'right',
        iconRoot: 'common',
        fluid: false,
        placeholder: '',
        uncontrolled: false,
        type: 'text',
        step: 1,
        disablePasswordToggle: false
    };
    return Input;
}(react_1.Component));
exports.default = Input;
